/*
 * File: install.js
 * File Created: Tuesday, 26th May 2020 3:21:38 pm
 * Author: yancr (yancr@lenovocloud.com)
 * -----
 * Last Modified: Tuesday, 26th May 2020 3:22:07 pm
 * Modified By: yancr (yancr@lenovocloud.com>)
 */

import Webtool from './index.vue'

// 定义插件对象
const CusWebTool = {}
// vue的install方法，用于定义vue插件
CusWebTool.install = function (Vue, options) {
  // 初始化实例
  const instance = new Vue({
    ...options,
    render(createElement) {
      return createElement(Webtool, {}, [])
    },
    methods: {
      init() {
        document.body.appendChild(this.$el)
      },
      destroy() {
        this.$destroy()
        this.removeDom()
      },
      removeDom() {
        if (this.$el && this.$el.parentNode === document.body) {
          document.body.removeChild(this.$el)
        }
      },
    },
    beforeDestory() {
      // 删除 dom
      this.removeDom()
      // 删除全局变量
      window.$bsWebTool = Vue.prototype.$bsWebTool = null
    },
  })
  // 挂载并且初始化
  instance.$mount()
  instance.init()
  const component = instance.$children[0]
  // 挂载组建实例到Vue原型上
  window.$bsWebTool = Vue.prototype.$bsWebTool = component
}
export default CusWebTool
